
import { BrowseStateBase } from "@/utils/browse/browse-state-base";
import Vue from "vue";
export default Vue.extend({
	props: {
		state: {
			type: Object as ()=>BrowseStateBase,
			required: true
		}
	}
});
